import { Suspense, lazy, ElementType } from 'react';
// components
import { LoadingScreen } from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
(
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

export const SignUpPageV1 = Loadable(lazy(() => import('../pages-v1/sign-up/signup-page')));